
import { QuoteWizardDefaultViewController } from './quoteWizardDefaultView.controller';
import core from '../core/core.module';
import idiRepositories from '../repositories/repository.module';
import { QuoteWizardNavigationService } from './quoteWizardNavigation.service';
import { QuoteWizardStateService } from './quoteWizardState.service';
import { TextInputComponent } from './components/singleInputComponents/text/textInput.component';
import { EmailController } from './quoteWizardSteps/custom/email/email.controller';

import { QuoteWizardNavigationController } from './quoteWizardNavigation/quoteWizardNavigation.controller';
import { QuoteWizardComponentFrameController } from './quoteWizardComponentFrame/quoteWizardComponentFrame.controller';
import { NumberInputComponent } from './components/singleInputComponents/number/numberInput.component';
import { YesNoInputComponent } from './components/singleInputComponents/yesNo/yesNoInput.component';
import { DateInputComponent } from './components/singleInputComponents/date/dateInput.component';
import { SelectInputComponent } from './components/singleInputComponents/select/selectInput.component';
import { IQuoteWizardStepsProvider, QuoteWizardStepsProvider } from './quoteWizardSteps/quoteWizardSteps.provider';
import { IQuoteWizardNode } from './quoteWizardNode';
import { PercentOrDollarInputComponent } from './components/singleInputComponents/percentOrDollar/percentOrDollarInput.component';
import { ReadonlyTextComponent } from './components/singleInputComponents/readonlyText/readonlyText.component';
import { AddressInputComponent } from './components/addressInput/addressInput.component';
import { BrandGateway } from './quoteWizardSteps/gateways/brand.gateway';
import { VerticalGateway } from './quoteWizardSteps/gateways/vertical.gateway';
import { PhoneGateway } from './quoteWizardSteps/gateways/phone.gateway';
import { AddAnotherLocationController } from './quoteWizardSteps/custom/addAnotherLocation/addAnotherLocation.controller';
import { BusinessTypeGateway } from './quoteWizardSteps/gateways/businessType.gateway';
import { QuoteWizardDefaultCustomViewController } from './quoteWizardSteps/custom/quoteWizardDefaultCustomView.controller';
import { PhoneController } from './quoteWizardSteps/custom/phone/phone.controller';
import { PolicyGateway } from './quoteWizardSteps/gateways/policy.gateway';
import { OwnBuildingController } from './quoteWizardSteps/custom/ownBuilding/ownBuilding.controller';
import { HaveLiquorSalesController } from './quoteWizardSteps/custom/haveLiquorSales/haveLiquorSales.controller';
import { QuoteWizardGateway } from './quoteWizard.gateway';
import { MailingAddressController } from './quoteWizardSteps/custom/mailingAddress/mailingAddress.controller';
import wizardNavigation from '../core/services/wizardNavigationService/wizardNavigation.module';
import { ClientStateContextRepository } from './repositories/clientStateContext.repository';
import { QuoteSummaryController } from './quoteWizardSteps/custom/quoteSummary/quoteSummary.controller';
import { SubmitRequestController } from './quoteWizardSteps/custom/submitRequest/submitRequest.controller';
import { ReferSummaryController } from './quoteWizardSteps/custom/referSummary/referSummary.controller';
import { ClaimTypesController } from './quoteWizardSteps/custom/claimTypes/claimTypes.controller';
import { ClaimsInLastThreeYearsController } from './quoteWizardSteps/custom/claimsInLastThreeYears/claimsInLastThreeYears.controller';
import { ReturningUserInfoController } from './returningUserInfo/returningUserInfo.controller';
import { WelcomeScreenController } from './welcomeScreen/welcomeScreen.controller';
import { GTMService } from './../core/services/gtm/gtm.service';

export default angular.module('idi.marketplace.quotewizard',
    ['focus-if',
        'ui.bootstrap',
        core,
        idiRepositories,
        wizardNavigation,
        'angulartics',
        'angulartics.google.tagmanager'
    ])
    .component('textInput', new TextInputComponent())
    .component('readonlyText', new ReadonlyTextComponent())
    .component('numberInput', new NumberInputComponent())
    .component('yesNoInput', new YesNoInputComponent())
    .component('dateInput', new DateInputComponent())
    .component('selectInput', new SelectInputComponent())
    .component('percentOrDollarInput', new PercentOrDollarInputComponent())
    .component('addressInput', new AddressInputComponent())
    .provider('gtmService', GTMService)
    .provider('quoteWizardStepsService', QuoteWizardStepsProvider)
    .service('quoteWizardStateService', QuoteWizardStateService)
    .service('quoteWizardGateway', QuoteWizardGateway)
    .service('quoteWizardNavigationService', QuoteWizardNavigationService)
    .service('brand.gateway', BrandGateway)
    .service('vertical.gateway', VerticalGateway)
    .service('phone.gateway', PhoneGateway)
    .service('businessType.gateway', BusinessTypeGateway)
    .service('policy.gateway', PolicyGateway)
    .service('clientStateContextRepository', ClientStateContextRepository)
    .controller('quoteWizardDefaultViewController', QuoteWizardDefaultViewController)
    .controller('quoteWizardDefaultCustomView.controller', QuoteWizardDefaultCustomViewController)
    .controller('quoteWizardNavigation.controller', QuoteWizardNavigationController)
    .controller('quoteWizardComponentFrame.controller', QuoteWizardComponentFrameController)
    .controller('email.controller', EmailController)
    .controller('phone.controller', PhoneController)
    .controller('addAnotherLocation.controller', AddAnotherLocationController)
    .controller('ownBuilding.controller', OwnBuildingController)
    .controller('haveLiquorSales.controller', HaveLiquorSalesController)
    .controller('mailingAddress.controller', MailingAddressController)
    .controller('quoteSummary.controller', QuoteSummaryController)
    .controller('submitRequest.controller', SubmitRequestController)
    .controller('referSummary.controller', ReferSummaryController)
    .controller('claimTypes.controller', ClaimTypesController)
    .controller('claimsInLastThreeYears.controller', ClaimsInLastThreeYearsController)
    .controller('returningUserInfo.controller', ReturningUserInfoController)
    .controller('welcomeScreen.controller', WelcomeScreenController)
    .run(moduleRun)
    .config(routeConfig)
    .name;

const moduleRootState: string = 'shellFrame.quoteWizardFrame.wizard';

routeConfig.$inject = ['$stateProvider', 'quoteWizardStepsServiceProvider', '$analyticsProvider'];

function routeConfig($stateProvider: ng.ui.IStateProvider, quoteWizardStepsServiceProvider: IQuoteWizardStepsProvider, $analyticsProvider: any): void {

    $analyticsProvider.firstPageview(false); /* Records pages that don't use $state or $route */
    $analyticsProvider.withAutoBase(false);  /* Records full path */
    $analyticsProvider.virtualPageviews(false);  /* Records full path */

    $stateProvider
        .state(moduleRootState, {
            url: '',
            views: {
                wizardnavigation: {
                    templateUrl: 'modules/quoteWizard/quoteWizardNavigation/quoteWizardNavigation.view.html',
                    controller: 'quoteWizardNavigation.controller',
                    controllerAs: 'vm'
                },
                wizardsteps: {
                    templateUrl: 'modules/quoteWizard/quoteWizardComponentFrame/quoteWizardComponentFrame.view.html',
                    controller: 'quoteWizardComponentFrame.controller',
                    controllerAs: 'vm',
                    abstract: true
                }
            },
            resolve: {}
        })
        .state(moduleRootState + '.returningUserInfo', {
            templateUrl: 'modules/quoteWizard/returningUserInfo/returningUserInfo.view.html',
            controller: 'returningUserInfo.controller',
            controllerAs: 'vm',
            data: { claimsProfile: { allowAnonymousAccess: false }, redirectToSignOn: 'shellFrame.authenticationFrame.login' },
            resolve: {}
        })
        .state(moduleRootState + '.welcomeScreen', {
            templateUrl: 'modules/quoteWizard/welcomeScreen/welcomeScreen.view.html',
            controller: 'welcomeScreen.controller',
            controllerAs: 'vm',
            data: { claimsProfile: { allowAnonymousAccess: true } },
            resolve: {}
        });

    for (const node of quoteWizardStepsServiceProvider.getWizardSteps()) {
        addStepState(node);
    }

    function addStepState(node: IQuoteWizardNode) {
        if (node.isDisplayNode !== false && !angular.isUndefined(node.stateConfig)) {
            $stateProvider.state(node.stateName, node.stateConfig);
        }
        if (!angular.isUndefined(node.repeatedNodes)) {
            for (const childNode of node.repeatedNodes) {
                addStepState(childNode);
            }
        }
    }
}

moduleRun.$inject = ['$rootScope', '$analytics', 'gtmService'];

function moduleRun($rootScope: angular.IRootScopeService, $analytics: any, gtmService: GTMService): void {
    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams) => {
        //only track wizard steps
        if (toState.name.indexOf(moduleRootState) > -1) {
            $analytics.pageTrack(toState.name.replace(/\./g, '/'));

        }
    });
}
